import { pages } from '../util/global-methods'

const routes = [
  {
    path: 'buy',
    name: 'buy',
    component: pages('buy/order-checkout'),
    props: true,
    query: { code: null },
    meta: { auth: true },
  },
  {
    path: 'buy/complete',
    component: pages('buy/order-complete'),
    props: true,
    meta: { auth: true },
  },
  {
    path: 'buy/fail',
    component: pages('error/fail'),
    props: true,
    query: { code: null, result: null },
    meta: { layout: 'default', auth: true },
  },
  /*
  {path: 'buy/coupon', component: pages('buy/coupon'), props: true},
  {path: 'buy/mileage', component: pages('buy/mileage'), props: true},
  {path: 'buy/checking', component: pages('buy/order-checking'), props: true},
*/
]

export default routes
